import iStorage from '../storage';
import simulator from '@/components/openIframe/dialog.js';
import tenantList from '@/assets/mock/common/tenantList.json';
import { getCookie, setCookie, removeCookie } from "tiny-cookie";
import getLoginUrl from './getLoginUrl.js';

/**
 *
 * interaction with webapps , ex: iaccount/ ievent/ icar/ imeal /ivenue /ijob
 *
 */
class simulatorBus {
	constructor() {

	}
	/**
	 *
	 */
	static async openiaccount() {
		let token = getCookie('token')
		let Uris = getCookie('Uris')
		if(token && Uris) {
			return;
		}
		if(!iStorage.get('loginUrl')) {
			getLoginUrl().then(response => {
				console.log(response)
				showIacccount();
			})
		} else {
			showIacccount();
		}

		function showIacccount() {
			var url = `${iStorage.get('loginUrl')}&container=simulator`;
			simulator.show({
				style: {
					width: 375,
					height: '90%',
					minHeight: '600px',
					clickToClose: false
				},
				frameUrl: url,
				handleMessage: function(message) {
					Object.keys(message.data).forEach(function(key) {
						var val = message.data[key];
						// 如果cookie中有tenant的话，应该将 web 去掉，如lillyweb 变为 lilly
						if(key == 'tenant') {
							tenantList.forEach(item => {
								if(val.indexOf(item.tenantName) > -1) {
									val = item.tenantName;
								}
							})
						}
						// 重新塞一次cookie，解决localhost登录问题
						if(val && val != "undefined") {
							setCookie(key, val, {
								expires: '31104000s',
								domain: window.idomain
							})
						} else {
							removeCookie(key, {
								domain: window.idomain
							})
							removeCookie(key, {
								domain: document.domain
							});
						}
					})
					location.reload(); // 重新加载当前页面，而不是simulator.close();
				}
			});
		}

	}

	static openievent({
		sendData,
		handleMessage,
		title,
		style
	}) {
		simulator.show({
			title: title || '',
			style: style || {
				width: 560,
				height: "90%"
			},
			frameUrl: `${iStorage.getUriSetting('webpart-ievent')}`, //提交这个地址，不要提交本地地址！！TODO
			sendData: sendData,
			handleMessage: handleMessage || function(message) {
				console.log(message);
				simulator.close();
			}
		});
	}

	static openimeal() {

	}
}

export default simulatorBus;